import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/accounting/position/filter'; // Importing Filter component
import Table from 'views/accounting/position/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the position view.
 * @extends JetView
 */
export default class positionView extends JetView {
    /**
     * Configures the layout of the position view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const screen = this.app.config.size; // Screen size configuration

        const right = {
            // Right section configuration
            type: 'wide',
            rows: [],
        };

        const toolbar = {
            // Toolbar configuration
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'],
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh data table
                        },
                    },
                },
                {
                    view: 'pager', // Pager configuration
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'ExportPosition',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            if (value == 1) {
                                // Excel export
                                var table = $$('datatable'); // Reference to the data table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Cargos'),
                                    ignore: { rating: true }, // Ignore rating column during export
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Cargos'),
                                        autowidth: true, // Automatically adjust width
                                        ignore: { rating: true }, // Ignore rating column during export
                                    });
                                }
                            }
                            $$('ExportPosition').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };

        const left = {
            // Left section configuration
            Width: 250,
            responsiveCell: false,
            rows: [
                {
                    view: 'toolbar', // Toolbar for left section
                    css: theme,
                    elements: [
                        { id: 'grav' }, // Placeholder element
                        {
                            cols: [
                                {
                                    view: 'button', // Button to add position
                                    value: _('Añadir Cargo'), // Button label
                                    type: 'form',
                                    width: screen == 'small' ? 0 : 200,
                                    minWidth: 250,
                                    hidden: !devConfig.getPermAction(
                                        // Check permissions for button visibility
                                        'accountingPositionAdd',
                                        'Add',
                                    ),
                                    css: 'prm-accountingPositionAdd',
                                    click: () => {
                                        // Click event handler
                                        this.app.callEvent(
                                            'addPosition:button',
                                            [{}], // Trigger add position event
                                        );
                                    },
                                },
                            ],
                        },
                    ],
                },
                Table, // Include Table component
                toolbar, // Include toolbar
            ],
        };

        webix.ui.fullScreen(); // Set UI to full screen mode
        return {
            // Return the main configuration object
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left], // Include left section
                },
            ],
        };
    }

    /**
     * Initializes the position view.
     */
    init() {
        if (screen.width < 500) {
            // Check screen width
            $$('grav').hide(); // Hide element if screen is small
        }
    }
}

// FILE DOCUMENTED
